/* iter55f81 — Notebook Digest opt-in toggle.
 *
 * Reads the current preference from `/api/notebook/preferences/digest`
 * and lets the writer opt out with a single click. Kept intentionally
 * small — one row inside Settings > Appearance so the writer can
 * find it near the other "how noisy should the app be" controls.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { Switch } from '@/components/ui/switch';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export default function NotebookDigestToggle() {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/notebook/preferences/digest`, { withCredentials: true })
      .then((r) => {
        if (!alive) return;
        setEnabled(Boolean(r.data?.enabled));
        setEmail(r.data?.email || '');
      })
      .catch(() => { /* leave defaults */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const onChange = async (v) => {
    setSaving(true);
    setEnabled(v);
    try {
      await axios.put(`${API}/notebook/preferences/digest`,
        { enabled: !!v }, { withCredentials: true });
      toast.success(v
        ? t('notebook.digestOn')
        : t('notebook.digestOff'));
    } catch {
      // Revert on failure
      setEnabled(!v);
      toast.error(t('notebook.couldNotSavePreference'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Switch
      checked={enabled}
      onCheckedChange={onChange}
      disabled={loading || saving}
      data-testid="settings-notebook-digest-toggle"
      aria-label={t('notebook.digestAriaLabel', {
        state: enabled ? t('notebook.enabled') : t('notebook.disabled'),
        email: email ? t('notebook.forEmail', { email }) : '',
      })}
    />
  );
}
